import React from "react";
import { DaisyDeposits } from "../../../models/daisydeposits.model";
import { getDaisyDepositRecords } from "../../../api/getDaisyDepositRecords";
import AddNewDepositModal from "./modals/AddNewDepositModal";
import RemoveDepositModal from "./modals/RemoveDepositModal";
import { System } from "../../../models/system.model";
import { currencyFormatter } from "../../../utils/currencyFormatter";
import ModifyDepositModal from "./modals/ModifyDepositModal";
import { responseHero } from "../../../utils/axiosInterceptor";

type DepositRegisterProps = {
    system: System | undefined;
}

export default function DepositRegister ({ system } : DepositRegisterProps) {
    const [records, setRecords] = React.useState<DaisyDeposits[]>([])
    const [originalRecords, setOriginalRecords] = React.useState<DaisyDeposits[]>([])
    const [totalAmount, setTotalAmount] = React.useState<number>(0);

    const [searchText, setSearchText] = React.useState<string>("");
    const [showNewRecordModal, setShowNewRecordModal] = React.useState<boolean>(false); // new record modal state
    const [recodsStateChange, setRecordsStateChange] = React.useState<boolean>(false)
    const [showRemoveRecordModal, setShowRemoveRecordModal] = React.useState<boolean>(false); // remove record modal state
    const [showModifiyModal, setShowModifiyModal] = React.useState<boolean>(false); // manual edit line
    const [selectedRecord, setSelectedRecord] = React.useState<DaisyDeposits>();
    const [selectedRecords, setSelectedRecords] = React.useState<Set<number>>(new Set());

    const toggleRecordSelection = (index: number) => {
        const newSet = new Set(selectedRecords);
        if (newSet.has(index)) {
            newSet.delete(index);
        } else {
            newSet.add(index);
        }
        setSelectedRecords(newSet);
    };    

    React.useEffect(() => {
        if(!system) return;

        getDaisyDepositRecords(true, system?.id)
        .then((response) => {
            setRecords(response)
            setOriginalRecords(response.filter((elem) => elem.relevance))
        })
        .catch((error) => {
            console.error(error);
        });
    }, [recodsStateChange, system])

    React.useEffect(() => {
        const filteredNames = filterNames(originalRecords, searchText, "name");
        
        filteredNames.map((filteredName) => filteredName.deposit)
        setTotalAmount(filteredNames.reduce((sum, filteredName) => sum + filteredName.deposit, 0));
        setRecords(filteredNames);
      }, [searchText, originalRecords]);

    const openNewRecordModal = () => {
        setShowNewRecordModal(true)
    };

    const openModifyRecordModal = () => {
        setShowModifiyModal(true)
    };

    const openRemoveRecordModal = () => {
        setShowRemoveRecordModal(true)
    };

    const closeModal = () => {
        setShowNewRecordModal(false)
        setShowRemoveRecordModal(false)
        setShowModifiyModal(false)
    };

    const handleStateChange = () => {
        setRecordsStateChange(!recodsStateChange)
    }

    const hideElements = async () => {
        try {
            const response = await responseHero.post(`${process.env.REACT_APP_API_URL}/daisydeposit/relevance`, 
                { ids: Array.from(selectedRecords) } );
            console.log(JSON.stringify(response));
            handleStateChange();
        } catch (error: any) {
            console.error(error.response?.data);
        }
    }

    const filterNames = (users: DaisyDeposits[], searchText: string, searchOption: string) => {
        const searchValue = searchText.toLowerCase();
        return users.filter((user) => {
          if (searchOption === 'name' && user.user) {
            return user.user.name.toLowerCase().includes(searchValue);
          }
          return true;
        });
      };

        return (
            <>
            <AddNewDepositModal system={system} title="Új adatsor" showModal={showNewRecordModal} closeModal={closeModal} handleStateChange={handleStateChange}/>
            <RemoveDepositModal title="Adatsor törlése" record={selectedRecord} showModal={showRemoveRecordModal} closeModal={closeModal} handleStateChange={handleStateChange}/>
            <ModifyDepositModal title={"Adatsor módosítása"} showModal={showModifiyModal} closeModal={closeModal} handleStateChange={handleStateChange} system={system} row={selectedRecord}/>
            <div className="m-10">
            <div className="flex flex-col lg:flex-row items-center justify-center text-center gap-4 mt-5 mb-4">
                <button
                className="text-white text-md px-4 py-2 bg-success rounded-md shadow hover:opacity-90 transition"
                onClick={() => openNewRecordModal()}
                >
                Új Befizetés hozzáadása
                </button>
                <div className="flex items-center gap-2">
                <label className="text-gray-500 text-md font-medium">Kereső:</label>
                <input
                    onChange={(e) => setSearchText(e.target.value)}
                    value={searchText}
                    type="text"
                    className="px-3 py-2 rounded-md bg-dark-blue text-white placeholder-gray-400 border border-gray-500 focus:outline-none focus:ring-2 focus:ring-brown"
                    placeholder="Ügyfél neve"
                />
                </div>
            </div>

            <p className="text-brown text-lg text-center mt-2 mb-4">
                Összesen a szűrés alapján:{" "}
                <span className="text-success font-semibold">{currencyFormatter(totalAmount, 'USD')}</span>
            </p>

            {selectedRecords.size > 0 && (
                <div className="flex justify-center items-center m-3">
                    <button onClick={hideElements} className="rounded-md px-2 py-2 bg-dark-brown text-gray-100 hover:bg-brown">
                        A kijelölt elemek elrejtése. ({selectedRecords.size} db)
                    </button>
                </div>
            )}
            

            <div className="overflow-x-auto rounded-md shadow-lg border border-gray-700 bg-dark-blue p-1">
                <table className="min-w-full divide-y divide-gray-600 text-white">
                <thead className="bg-brown sticky top-0 z-10 shadow-sm text-sm">
                    <tr>
                    <th className="px-4 py-3 text-left">Sorszám</th>
                    <th className="px-4 py-3 text-left">Dátum</th>
                    <th className="px-4 py-3 text-left">Ügyfél neve</th>
                    <th className="px-4 py-3 text-left">Csoport neve</th>
                    <th className="px-4 py-3 text-left">Beutalt összeg</th>
                    <th className="px-4 py-3 text-left">Ebből a csoportból</th>
                    <th className="px-4 py-3 text-left">Ebbe a csoportba</th>
                    <th className="px-4 py-3 text-center" colSpan={2}>Műveletek</th>
                    <th className="px-4 py-3 text-left">Kiválasztás</th>

                    </tr>
                </thead>
                <tbody className="divide-y divide-gray-700 text-sm">
                    {records.map((record, index) => (
                    <tr
                        key={index}
                        className="hover:bg-gray-800 transition-colors even:bg-dark-blue odd:bg-light-blue"
                    >
                        <td className="px-4 py-3">{index + 1}.</td>
                        <td className="px-4 py-3">{record.date.toString().split("T")[0]}</td>
                        <td className="px-4 py-3">{record?.user?.name}</td>
                        <td className="px-4 py-3">{record?.group?.group_name}</td>
                        <td className="px-4 py-3">{currencyFormatter(record.deposit, "USD")}</td>
                        <td className={`px-4 py-3 ${record?.fromGroup ? 'text-cream' : 'text-gray-500'}`}>
                        {record.fromGroup?.group_name || "Banki beutalás"}
                        </td>
                        <td className={`px-4 py-3 ${record?.toGroup ? 'text-cream' : 'text-gray-500'}`}>
                        {record.toGroup?.group_name || "Banki beutalás"}
                        </td>
                        <td className="px-2 py-3 text-center">
                        <button
                            onClick={() => {
                            setSelectedRecord(record)
                            openModifyRecordModal()
                            }}
                            className="text-cream hover:text-brown font-semibold transition"
                        >
                            Módosítás
                        </button>
                        </td>
                        <td className="px-2 py-3 text-center">
                        <button
                            onClick={() => {
                            setSelectedRecord(record)
                            openRemoveRecordModal()
                            }}
                            className="text-error hover:text-brown font-semibold transition"
                        >
                            Törlés
                        </button>
                        </td>

                        <td className="px-4 py-3 text-center">
                            <input
                                type="checkbox"
                                checked={selectedRecords.has(record.id)}
                                onChange={() => toggleRecordSelection(record.id)}
                                className="form-checkbox accent-cream h-6 w-6 text-brown"
                            />
                        </td>
                    </tr>
                    ))}
                </tbody>
                </table>
            </div>
        </div>
    </>
    )
    
}